import { Box } from '@mui/material';
import animationData from 'assets/lottie/Loading-Circle-Loop.json';
import { FC } from 'react';
import Lottie from 'lottie-react';

interface LoadingCircleLoopProps {
    width?: number;
    height?: number;
}

export const LoadingCircleLoop: FC<LoadingCircleLoopProps> = ({ width = 100, height = 100 }) => {
    return (
        <Box className="w-full flex justify-center items-center">
            <Lottie animationData={animationData} style={{ width: width, height: height }} loop={true} autoplay={true} />
        </Box>
    );
};